module.exports = __webpack_public_path__ + "static/img/xk.b9df535c.svg";